import template        from "./button-fermentation-inoculate.html";
import css             from "./button-fermentation-inoculate.css";

import { Button }      from "gui";


class InoculateFermentationButton extends Button {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-button-fermentation-inoculate", InoculateFermentationButton);
  }
  static get schema() {
    return({
      "description": "User defined button that is disabled when there is not running fermentation",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }
  constructor(...args) {
    super(...args);

    this.disabled = true;

    this.addEventListener("click", this.onclick_handler.bind(this));
    document.addEventListener("onupdatefermentations", this.onupdatefermentations_handler.bind(this));
  }
  onupdatefermentations_handler(event) {
    var fermentations = event.detail;

    this.disabled = true;

    for (const fermentation of fermentations) {  
      if (fermentation.running && !fermentation.inoculationDate) {
        this.disabled = false;
        this.__id = fermentation.id;
      }
    }
  }
  async onclick_handler() {
    if (!(await confirm("Are you sure you wish to inoculate?"))) return;

    try {
      const resp = await fetch(`/api/pc/fermentations/${this.__id}`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json'
        }
      });

      if (!resp.ok) throw new Error(`${resp.status}`);

      let fermentation = await resp.json();

      fermentation.inoculationDate = new Date();

      const resp2 = await fetch(`/api/pc/fermentations/${this.__id}`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(fermentation)
      });

      if (!resp2.ok) throw new Error(`${resp2.status}`);

      alert("Inodulation date successfully registered.");
    } catch(e) {
      error(e.message);
    }
  }
}

InoculateFermentationButton.constructor();

export default InoculateFermentationButton;